import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  Statusstudent_document,
} from "../../../../../../features/admin/masters/studentDocument/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const student_document = useSelector(
    (state) => state.masters?.studentDocument
  );

  console.log(student_document, "student_document");

  // const all_country = useSelector((state) => state.common.all_country);
  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = student_document?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: student_document?.per_page,
      })
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(Statusstudent_document(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    student_document,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  };
};
